import { objectToSearchParams } from './object-to-searchparams';
import { parseParams } from './parse-params';

export const appendQueryParam = (locationSearch, navigate, queryObjects) => {
	const search = parseParams(locationSearch);
	queryObjects.forEach(query => {
		const key = Object.keys(query)[0];
		const val = Object.values(query)[0];
		search[key] = val;
	});
	navigate(objectToSearchParams(search));
};
